module.exports = __webpack_public_path__ + "static/media/Merienda-Regular.4e862534.ttf";